import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import { S_PART } from '@lba-dev/package.local-globals/services';

const state = {
  selectedPage: null,
  selectedTeam: null,
};

/**
 * withEquipesTab is a higher-order component used to display
 * a equip tab selector above of the different lists throughout the application
 *
 * @returns {React.Node}
 */
export default function withEquipesTab({ fieldName = 'address.zipcode' }) {
  const mapStateToProps = ({ users, counters }) => ({
    usersTeams: users.filter(
      (user) => user.service === S_PART && user.act && user.equipe
    ),
    counters,
  });

  return (WrappedComponent) =>
    connect(mapStateToProps)(
      class extends Component {
        state = state;

        handleChangeTeam = (chiefId) => {
          this.setState({
            selectedTeam: chiefId,
          });
        };

        render() {
          const { selectedTeam } = this.state;
          const { usersTeams, counters } = this.props;

          return (
            <React.Fragment>
              <Paper>
                <Grid
                  container
                  align="center"
                  spacing={2}
                  justifyContent="center"
                >
                  {[
                    ...usersTeams.map((e) => (
                      <Grid item xs={2} key={e._id}>
                        <Badge
                          badgeContent={counters ? counters[e._id] : 0}
                          color="secondary"
                        >
                          <Button
                            style={{
                              ...(selectedTeam !== e._id
                                ? {
                                  color: e.equipe.color,
                                  border: `1px solid ${e.equipe.color}`,
                                }
                                : { backgroundColor: e.equipe.color }),
                            }}
                            onClick={() => this.handleChangeTeam(e._id)}
                            variant={
                              selectedTeam === e._id ? 'contained' : 'outlined'
                            }
                            children={e.equipe.name}
                          />
                        </Badge>
                      </Grid>
                    )),
                    <Grid key={2} item xs={2}>
                      <Button
                        color="inherit"
                        onClick={() => this.handleChangeTeam(null)}
                        variant={
                          selectedTeam === null ? 'contained' : 'outlined'
                        }
                        children={'Général'}
                      />
                    </Grid>,
                  ]}
                </Grid>
              </Paper>
              <WrappedComponent
                {...this.props}
                filters={
                  selectedTeam
                    ? {
                      [fieldName]: {
                        $in: usersTeams
                          .find((e) => e._id === selectedTeam)
                          .areas.map((e) => `/^${e}/`),
                      },
                    }
                    : {}
                }
              />
            </React.Fragment>
          );
        }
      }
    );
}
